import {
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SchedulerBaseItem, SchedulerItem } from '../../models/item';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { SchedulerListService } from './list.service';
import { MatTableModule } from '@angular/material/table';
import { SchedulerListDragDropService } from '../../services/list-drag-drop.service';
import { DragAndDropEvent } from '../../../drag-drop/types/event';
import { SchedulerItemOnListDirective } from '../../directives/template.directive';
import { SchedulerListDirective } from './list.directive';

@Component({
  standalone: true,
  selector: 'app-scheduler-list',
  templateUrl: './list.component.html',
  imports: [
    CommonModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatCardModule,
    ReactiveFormsModule,
    TranslateModule,
    MatInputModule,
    MatTableModule,
    SchedulerListDirective,
  ],
  styleUrls: ['./list.component.sass'],
})
export class SchedulerListComponent implements OnInit, OnDestroy {
  @Input() showFilterForm = true;

  @Input() titleOfFilter = 'Filtrado';
  @Input() titleOfList = '';
  @Input() classTitleOfList = 'tw-bg-black';
  @Input() showEmptyTitles = true;

  selectedOrientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() set orientation(val: 'horizontal' | 'vertical') {
    this.changeOrientation(val);
  }
  @Input() set idList(value: string) {
    this.service.idList = value;
  }
  get idList(): string {
    return this.service.idList;
  }
  get formSearch(): FormGroup {
    return this.service.form;
  }

  filteredList$ = this.service.filteredList$;
  list$ = this.service.list$;
  disableMovement$ = this.service.disableMovement$;

  viewForTablet = false;
  subscription: Subscription = null;

  @ContentChild(SchedulerItemOnListDirective, { read: TemplateRef })
  templateItem: TemplateRef<any> | undefined = undefined;

  @ViewChildren('itemContainer') itemContainers: ElementRef<HTMLDivElement>[];

  constructor(
    private readonly service: SchedulerListService<SchedulerBaseItem>,
    private readonly layoutService: LayoutService,
    private readonly dragDropService: SchedulerListDragDropService<SchedulerBaseItem>
  ) {}

  ngOnInit(): void {
    this.subscription = this.layoutService.viewForTablet$.subscribe(
      (isTabletView) => (this.viewForTablet = isTabletView)
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  drop(event: DragAndDropEvent<SchedulerItem>): void {
    this.service
      .validateForDragDrop(event)
      .then((val) => {
        if (val) {
          return this.dragDropService.onDrop(event);
        }
      })
      .then((list: SchedulerItem[]) => {
        if (list && Array.isArray(list)) {
          this.service.list = list;
        }
      });
  }

  changeOrientation(val: 'horizontal' | 'vertical'): void {
    if (val === this.selectedOrientation) {
      return;
    }
    this.selectedOrientation = val;
  }

  setMinWidth(el: HTMLDivElement): { [p: string]: any } {
    if (
      this.selectedOrientation === 'horizontal' &&
      this.itemContainers.length > 1
    ) {
      const first = this.itemContainers.find(
        (item) => el.id !== item?.nativeElement?.id
      );
      // console.log(first.nativeElement.clientWidth, first.nativeElement);
      if (first?.nativeElement?.clientWidth) {
        return {
          minWidth: first?.nativeElement?.clientWidth + 'px',
        };
      }
    }
    return {
      minWidth: '100%',
    };
  }
}
